module.exports = __webpack_public_path__ + "static/img/NG@3x.eb4b9620.jpg";